import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createStore } from './create-store';

export interface IFleetInsightsFilter {
  date: Dayjs;
  warehouseId?: number;
  fromWarehouseId?: number;
  toWarehouseId?: number;
}

type TState = {
  filters: IFleetInsightsFilter;
};

type TActions = {
  setFilters: (value: IFleetInsightsFilter | undefined) => void;
};

export const useFleetInsightsFiltersStore = createStore<TState & TActions>(
  (set) => ({
    filters: { date: dayjs() },
    setFilters: (filters: IFleetInsightsFilter | undefined) => set((state) => ({ ...state, filters })),
  }),
  'fleet-insights-filters-store',
);
